import { type ReactNode } from "react";
import { createPortal } from "react-dom";

/**
 * Renders chatbot UI into document.body so position:fixed is always relative to
 * the viewport, not a transformed or scrollable ancestor.
 */
export function ChatbotViewportPortal({
  children,
}: {
  children: ReactNode;
}): ReturnType<typeof createPortal> {
  return createPortal(children, document.body);
}
